import React from 'react'
import { groupBy } from 'lodash'
import { updateContextState } from '@tools/wr-catalog-base'

import { getObjective } from '@utils/addons'
import PtcCartProduct from '@components/PtcCartProduct'
import Toggle from '@components/Toggle'
import SimpleSortable from './index'

import { Section, Container, PhaseLabel, ObjectiveLabel } from './styles'

const generateDndList = (window.generateDndList = (items, sections, showEmpties) => {
  const itemsBySection = groupBy(items, (item) => getObjective(item, sections))

  const dndList = []
  let currentPhase = null

  const addSection = (tag, label, addIfEmpty) => {
    const sectionItems = itemsBySection[tag] || []
    if (!sectionItems.length && !addIfEmpty) return

    const id = `section${tag}`
    const dndSection = {
      id,
      isSection: true,
      tag,
      label,
      phase: tag === 'objective:addons' ? null : currentPhase,
      isEmpty: !sectionItems.length,
    }
    // Reset it so it doesn't get duplicated
    currentPhase = null
    dndList.push(dndSection)
    sectionItems.forEach((item) => {
      dndList.push({
        id: item.cartItemId,
        item,
      })
    })
  }

  addSection('unknown', 'Unknown Objective', false)
  sections.forEach(({ tag, label }) => {
    if (tag === 'phase') currentPhase = label
    else addSection(tag, label, showEmpties)
  })
  return dndList
})

const onDragEnd = ({ newIndex, oldIndex }, dndList) => {
  if (oldIndex === newIndex) return
  // Increment by 1 as the first list element isn't counted in the dnd
  oldIndex++
  newIndex++

  const [node] = dndList.splice(oldIndex, 1)
  dndList.splice(newIndex, 0, node)
  let sectionKey = null
  dndList.some((child) => {
    if (child.isSection) sectionKey = child.tag
    return child === node
  })
  node.item.section = sectionKey

  // The item's section is updated. Just trigger a re-render
  updateContextState((state) => {})
}

const renderDraggable = ({ item: dndItem, provided }) => (
  <Section
    ref={provided.innerRef}
    {...provided.draggableProps}
    {...provided.dragHandleProps}
    isIndented={dndItem.phase}
  >
    {dndItem.isSection ? (
      <>
        {dndItem.phase && <PhaseLabel>{dndItem.phase}</PhaseLabel>}
        <ObjectiveLabel isEmpty={dndItem.isEmpty}>{dndItem.label}</ObjectiveLabel>
      </>
    ) : (
      <PtcCartProduct cartProduct={dndItem.item} />
    )}
  </Section>
)

const arrayMoveMutable = (array, from, to) => {
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0])
  return array
}

export default function SortableCart(props) {
  const {
    cart: [mainItem, ...addons],
    isDropdownCart,
  } = props

  const [showEmpties, setShowEmpties] = React.useState(false)

  if (!mainItem.usesAddOnItems) {
    const dndItems = props.cart.map((item) => ({ item, id: item.cartItemId }))
    return (
      <Container className="simple-cart">
        <SimpleSortable
          data={dndItems}
          onReorder={({ oldIndex, newIndex }) => {
            updateContextState((state) => {
              state.cart = arrayMoveMutable(
                dndItems.map((d) => d.item),
                oldIndex,
                newIndex,
              )
            })
          }}
          getDraggableProps={(dndItem) => ({ isDragDisabled: dndItem.isSection })}
          renderDraggable={renderDraggable}
        />
      </Container>
    )
  }

  const dndList = generateDndList(addons, mainItem.sections || [], showEmpties)
  const [firstSection, ...movingList] = dndList
  return (
    <Container>
      <PtcCartProduct cartProduct={mainItem} />
      {!isDropdownCart && (
        <label style={{ margin: '10px 40px', display: 'inline-block' }}>
          <Toggle checked={showEmpties} onChange={(ev) => setShowEmpties(ev.target.checked)} />
          {' Show all tasks'}
        </label>
      )}
      {firstSection && (
        <Section phase>
          <PhaseLabel>{firstSection.phase}</PhaseLabel>
          <ObjectiveLabel isEmpty={firstSection.isEmpty}>{firstSection.label}</ObjectiveLabel>
        </Section>
      )}
      <SimpleSortable
        data={movingList}
        onReorder={(result) => onDragEnd(result, dndList)}
        getDraggableProps={(dndItem) => ({ isDragDisabled: dndItem.isSection })}
        renderDraggable={renderDraggable}
      />
    </Container>
  )
}
